import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { beautyBaseUrl } from "network";

export const subCategorySlice = createApi({
    reducerPath: "subCategorySlice",
    baseQuery: fetchBaseQuery({
        baseUrl: beautyBaseUrl,
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("Authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getSubCategories: builder.query({
            query: ({ page = 1, limit = 100, search = "" }) => ({
                url: `/subcategory?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addSubCategory: builder.mutation({
            query: (body) => ({
                url: "/subCategory",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateSubCategory: builder.mutation({
            query: ({ id, body }) => ({
                url: `/subCategory/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteSubCategory: builder.mutation({
            query: (id) => ({
                url: `/subCategory/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetSubCategoriesQuery,
    useAddSubCategoryMutation,
    useUpdateSubCategoryMutation,
    useDeleteSubCategoryMutation
} = subCategorySlice;
